let verificationTypeRoutes = [
  {
    path: '/',
    component: () => import('Modules/Dashboard/resources/layout/DashboardLayout.vue'),
    children: [
      { path: 'verification-types', name: 'verification-types.list', component: () => import('./pages/Index.vue') },
      { path: 'verification-types/create', name: 'verification-types.create', component: () => import('./pages/Create.vue') },
      { path: 'verification-types/:id/edit', name: 'verification-types.edit', component: () => import('./pages/Edit.vue') }
    ]
  }
];

export default verificationTypeRoutes;
